<template>
  <div id="term-create-details-tab" @keyup.ctrl.enter="term_update_data">
    <div class="vx-col w-full">
      <div class="vx-row ">
        <div class="vx-col w-full mb-6 ">
          <vs-input v-model="data_local.term_id" class="w-full" label-placeholder="Term ID" readonly/>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6 ">
          <vs-input v-model="data_local.term_name" class="w-full" label-placeholder="Term Name"/>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6 ">
          <vs-select class="w-full mt-5" placeholder="Term Status" v-model="data_local.term_status">
            <vs-select-item :key="index" :value="option" :text="option.charAt(0).toUpperCase() + option.slice(1)" v-for="(option,index) in statusOptions"/>
          </vs-select>
        </div>
      </div>
      <div class="vx-row  mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Thumbnail URL" v-model="data_local.term_thumbnail"/>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-textarea v-model="data_local.term_description" :counter-danger.sync="term_description_counter" counter="400"
                       height="100px" label="Term Description"/>
        </div>
      </div>
      <div class="vx-row  mb-8">
        <div class="vx-col w-full">
          <div class="grid grid-cols-5 gap-4">
            <div class="flex items-center justify-between">
              <h3>Enable Practice</h3>
              <vs-switch v-model="data_local.term_practice_enabled"/>
            </div>
            <div class="flex items-center justify-between">
              <h3>Enable Flashcard</h3>
              <vs-switch v-model="data_local.term_flashcard_enabled"/>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mb-2 mr-2" color="success" type="filled"
                     @click="term_update_data">Update Term
          </vs-button>
          <vs-button class="mb-2 ml-2" color="warning" type="border"
                     @click="reterm_data">Reterm
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      term_description_counter: null,

      statusOptions: [
        'active',
        'hidden',
        'disabled'
      ]
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    term_update_data () {
      this.$emit('update_termData', this.data_local)
    },
    reterm_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>

<style scoped>

</style>
